import React, { useEffect, useState } from 'react';

function SalesInvoiceSearchTable({ records, onCreateInvoice, onViewInvoice }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!Array.isArray(records) || records.length === 0) {
    return <div className="text-center text-muted mt-3">No data found. Apply filters and search.</div>;
  }

  if (isMobile) {
    return (
      <div className="mt-3">
        {records.map((row, index) => (
          <div key={row.planning_id} className="card mb-3 shadow-sm rounded-4 border border-primary">
            <div className="card-body small">
              <h6 className="fw-bold text-primary">#{index + 1}. {row.customer_name}</h6>
              <div><strong>SO No:</strong> {row.customer_po_no}</div>
              <div><strong>PO Date:</strong> {row.po_date}</div>
              <div><strong>Planning ID:</strong> {row.planning_id}</div>
              <div><strong>Planning Date:</strong> {row.plan_created_on}</div>
              <div><strong>Delivery Date:</strong> {row.delivery_date}</div>
              <div><strong>Destination:</strong> {row.destination}</div>
              <div><strong>Material:</strong> {row.material_name}</div>
              <div><strong>Planned QTY:</strong> {row.planned_qty} {row.unit}</div>
              <div><strong>Packing:</strong> {row.packing_style}</div>
              <hr />
              Vehicle Planning Information
              {(row.dispatches || []).map((dispatch, i) => {
                const invoice = (row.invoices || [])[i];
                const isInvoiced = invoice && invoice.tally_invoice_no;
                return (
                  <div key={dispatch.dispatch_id} className="border-top pt-2 mt-2">
                    <div><strong>Dispatch Date:</strong> {dispatch.dispatch_date}</div>
                    <div><strong>Driver:</strong> {dispatch.driver_name}</div>
                    <div><strong>Vehicle:</strong> {dispatch.vehicle_no}</div>
                    <div><strong>Diesel (Ltrs):</strong> {dispatch.diesel_ltr}</div>
                    <div><strong>Cash (₹):</strong> {dispatch.cash_amount}</div>
                    <div><strong>Remark:</strong> {dispatch.remark}</div>
                    <div><strong>Invoice:</strong>{' '}
                      {isInvoiced ? (
                        <span className="badge bg-success">✔️ {invoice.tally_invoice_no}</span>
                      ) : (
                        <span className="text-muted">Not Created</span>
                      )}
                    </div>
                    <div className="mt-2">
                      {isInvoiced ? (
                        <button className="btn btn-sm btn-outline-primary" onClick={() => onViewInvoice(invoice.invoice_item_id)}>
                          View Invoice
                        </button>
                      ) : (
                        <button className="btn btn-sm btn-success" onClick={() => onCreateInvoice([dispatch.dispatch_id])}>
                          Create Invoice
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="mt-3" style={{ overflowX: 'auto' }}>
      <table className="table table-bordered table-hover table-sm small" style={{ minWidth: '100%' }}>
        <thead className="table-light">
          <tr>
            <th>Sr. No</th>
            <th>Customer Name</th>
            <th>SO No</th>
            <th>Planning ID</th>
            <th>Planning Date</th>
            <th>Delivery Date</th>
            <th>Destination</th>
            <th>Material</th>
            <th>Planned QTY</th>
            <th>Packing Type</th>
            <th>Vehicle Details</th>
            <th>Billing Details</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {records.map((row, index) => {
            const dispatches = row.dispatches || [];
            const invoices = row.invoices || [];
            const count = Math.max(dispatches.length, invoices.length);

            return Array.from({ length: count }).map((_, i) => {
              const dispatch = dispatches[i] || {};
              const invoice = invoices[i];
              const isInvoiced = invoice && invoice.tally_invoice_no;
              return (
                <tr key={`${row.planning_id}-${i}`}>
                  {i === 0 && <td rowSpan={count}>{index + 1}</td>}
                  {i === 0 && <td rowSpan={count}>{row.customer_name}</td>}
                  {i === 0 && (
                    <td rowSpan={count}>
                      {row.customer_po_no}<br />{row.po_date}
                    </td>
                  )}
                  {i === 0 && <td rowSpan={count}>{row.planning_id}</td>}
                  {i === 0 && <td rowSpan={count}>{row.plan_created_on}</td>}
                  {i === 0 && <td rowSpan={count}>{row.delivery_date}</td>}
                  {i === 0 && <td rowSpan={count}>{row.destination}</td>}
                  {i === 0 && <td rowSpan={count}>{row.material_name}</td>}
                  {i === 0 && <td rowSpan={count}>{row.planned_qty} {row.unit}</td>}
                  {i === 0 && <td rowSpan={count}>{row.packing_style}</td>}
                  <td>
                    {dispatch.driver_name}<br />{dispatch.vehicle_no}
                     <div><strong>Diesel:</strong> {dispatch.diesel_ltr}</div>
                    <div><strong>Cash:</strong> ₹{dispatch.cash_amount}</div>
                    <div><strong>Remark:</strong> {dispatch.remark}</div>
                  </td>
                
                <td>
  {isInvoiced ? (
    <>
      <div><strong>No:</strong> {invoice.tally_invoice_no}</div>
      <div><strong>Qty:</strong> {invoice.invoiced_qty} {row.unit}</div>
    </>
  ) : (
    <span className="text-muted">Not Created</span>
  )}
</td>

                  <td>
                    {isInvoiced ? (
                      <button className="btn btn-sm btn-outline-primary" onClick={() => onViewInvoice(invoice.invoice_item_id)}>
                        View Invoice
                      </button>
                    ) : (
                      <button className="btn btn-sm btn-success" onClick={() => onCreateInvoice([dispatch.dispatch_id])}>
                        Create Invoice
                      </button>
                    )}
                  </td>
                </tr>
              );
            });
          })}
        </tbody>
      </table>
    </div>
  );
}

export default SalesInvoiceSearchTable;
